export default {
  login: "ChuksMbanaso",
  id: 89187837,
  node_id: "MDQ6VXNlcjg5MTg3ODM3",
  avatar_url: "https://avatars.githubusercontent.com/u/89187837?v=4",
  gravatar_id: "",
  url: "https://api.github.com/users/ChuksMbanaso",
  html_url: "https://github.com/ChuksMbanaso",
  followers_url: "https://api.github.com/users/ChuksMbanaso/followers",
  following_url:
    "https://api.github.com/users/ChuksMbanaso/following{/other_user}",
  gists_url: "https://api.github.com/users/ChuksMbanaso/gists{/gist_id}",
  starred_url:
    "https://api.github.com/users/ChuksMbanaso/starred{/owner}{/repo}",
  subscriptions_url: "https://api.github.com/users/ChuksMbanaso/subscriptions",
  organizations_url: "https://api.github.com/users/ChuksMbanaso/orgs",
  repos_url: "https://api.github.com/users/ChuksMbanaso/repos",
  events_url: "https://api.github.com/users/ChuksMbanaso/events{/privacy}",
  received_events_url:
    "https://api.github.com/users/ChuksMbanaso/received_events",
  type: "User",
  site_admin: false,
  name: "D-coder",
  company: "Freelancer",
  blog: "",
  location: "Lagos, Nigeria",
  email: null,
  hireable: true,
  bio: "Industrial Engineering Graduate, Tech Enthusiast, Web Developer and Designer.",
  twitter_username: "Chuksmbanaso",
  public_repos: 20,
  public_gists: 0,
  followers: 6,
  following: 8,
  created_at: "2021-08-19T08:30:52Z",
  updated_at: "2021-12-12T05:30:34Z",
};
